export default "__VITE_ASSET__BmUHVW9L__"